const riot = require('riot');
import xor from 'bitwise-xor';
import ObjectId from 'bson-objectid';
riot.tag2('tagging', '<div class="level"> <div class="level-left"> <h1 class="title is-5 level-item">User tags overview</h1> </div> <div class="level-right"> <form onsubmit="{setSearchFilter(null,0)}" class="level-item"> <div class="field is-grouped"> <div class="control"> <div class="select is-small"> <select name="market" ref="market" onchange="{setMarketFilter()}"> <option value="">Select market</option> <option each="{m in market_options}" selected="{filter.market==m._id}" riot-value="{m._id}">{m.name}</option> </select> </div> </div> <div class="control"> <div class="select is-small"> <select name="customer" ref="customer" onchange="{setCustomerFilter()}"> <option value="">Select customer</option> <option each="{m in customers}" selected="{filter.customer_id && filter.customer_id._oid==m._id}" riot-value="{m._id}">{m.name}</option> </select> </div> </div> <div class="control has-icons-right" style="flex-shrink:1"> <input class="input is-info {is-warning:search_active} is-small" ref="new_name" oninput="{setSearchFilter(null,500)}" type="text" placeholder="Enter/Search tag" riot-value="{filter.$or ? filter.$or[0].name.$regex : \'\'}"> <span class="icon is-small is-right" onclick="{clearSearch}" style="cursor:pointer;pointer-events:all"> <i class="fas {fa-times:!search_active,fa-spin:search_active,fa-spinner:search_active}"></i> </span> </div> <div class="control"> <span class="button is-info is-small" onclick="{createTag}">Add <span class="is-hidden-mobile">Tag</span></span> </div> </div> </form> </div> </div> <nav class="buttons has-addons" style="justify-content:center"> <button class="button is-small" each="{letter in abc}" onclick="{setSearchFilter(\'^\'+letter,0)}">{letter}</button> </nav> <div class="container"> <div each="{route_tags}" class="card"> <header class="card-header {has-background-light:editing==_id}"> <div class="card-header-title" style="display:block;font-weight:normal;padding:0.25rem 0.5rem"> <strong>{name}</strong> <a onclick="{setCustomerFilter(customer_id)}"><small>{customer && customer.name || customer_id}</small></a> <br> <small>{link || \'-- no link --\'}</small> </div> <div class="card-header-icon" aria-label="more options" style="padding:1rem 0.5rem"> <span if="{tag_data[_id]}" class="tag is-small is-success" title="Cookie count">{tag_data[_id].uniq || \'0\'}</span>&nbsp;&nbsp; &nbsp;&nbsp; <a onclick="{grabEdit}"> <span class="icon is-small is-marginless"><i class="fa {fa-times:editing==_id,fa-caret-down:editing!=_id}"></i></span> </a> </div> </header> <div if="{editing==_id}" class="card-content has-background-white-bis columns" style="margin:0"> <fieldset class="column"> <div class="field"> <label class="label is-small">Tag</label> <div class="control"> <input class="input is-small" ref="item_name" onchange="{saveItem(\'name\')}" type="text" placeholder="Enter tag" riot-value="{name}"> </div> </div> <div class="field"> <label class="label is-small">Link</label> <div class="control"> <input class="input is-small" ref="item_link" onchange="{saveItem(\'link\')}" type="text" placeholder="Enter link" riot-value="{link}"> </div> </div> </fieldset> </div> <footer if="{editing==_id}" class="card-footer has-background-white-bis" style="margin-bottom:1rem"> <button class="card-footer-item button is-small" title="{_id}" onclick="{copyAttribute(\'title\',\'ID\')}">copy tag ID</button> <button class="card-footer-item button is-small" title="{tiny_pixel}" onclick="{copyAttribute(\'title\',\'Pixel\')}">copy pixel</button> <button class="card-footer-item button is-small" disabled="{!!!tiny_link}" title="{tiny_link}" onclick="{copyAttribute(\'title\',\'Link\')}">copy link</button> <button class="card-footer-item button is-small is-danger" onclick="{deleteItem}">delete tag</button> </footer> </div> </div> <div class="level mt-3"> <div class="level-left"> <div class="level-item"> <button if="{!end_of_line}" class="button is-small is-info" onclick="{loadMore}">Load more</button> </div> </div> </div>', '', '', function(opts) {

  const tiny_base = 'https://tinyurl.com/api-create.php?url=';

  var self = this,
      conf = api.get('config'),
      salt = conf.authentication.secret,
      encrypt = (str) => xor(str,salt).toString('hex'),
      decrypt = (str) => xor(new Buffer.from(str,'hex'),salt).toString(),
      tinyURL = (url) => fetch(tiny_base+url).then(r => r.text())

  self.devel = conf.mode=='development'
  self.elasticUrl = conf.elasticUrl

  var filters = api.get('filters')
  filters['tagging'] = filters['tagging'] || {$sort:{name:1,_id:1},$limit:20}
  self.filter = filters['tagging']
  self.customers = []

  self.market_options = api.get('markets')

  this.setMarketFilter = function(val) {
    return function(e) {
      e.preventDefault()
      val = val || self.refs.market.value
      if (!!val) {
        self.filter.market = val
        delete self.filter.customer_id
      } else delete self.filter.market;
  console.log('filter',self.filter)
      e.preventUpdate = true
      loadTags()
    }
  }.bind(this)

  this.setCustomerFilter = function(val) {
    return function(e) {
      e.preventDefault()
      val = val || self.refs.customer.value
      if (!!val) {
        self.filter.customer_id = {_oid:val}

      } else delete self.filter.customer_id;
  console.log('filter',self.filter)
      e.preventUpdate = true
      loadTags()
    }
  }.bind(this)

  this.decrypt = function(str) {
  console.log('decrypting',str)
    return str && decrypt(str) || ''
  }.bind(this)

  self.search_active = false
  self.abc = 'abcčdefghijklmnoprqsštvuvxyzž'

  var search_string = '', search_tmout = false
  function setSearch(str,delay) {

    if (str) {
      self.filter.$or = [
        {name : {
          $regex: str,
          $options: 'i'
        }},
        {tag_id : {
          $regex: str,
          $options: 'i'
        }}
      ]
    } else delete self.filter.$or
console.log('filter',self.filter)
    if (search_tmout) clearTimeout(search_tmout)
    search_tmout = setTimeout(loadTags,delay)
  }
  this.setSearchFilter = function(val,delay) {
    return function(e) {
      e.preventDefault()
      val = val || self.refs.new_name.value
      self.refs.new_name.value = val
      setSearch(val,delay)

    }
  }.bind(this)
  this.clearSearch = function(e) {
    e.preventDefault()
    self.refs.new_name.value = ''
    setSearch('')
    e.preventUpdate = true
  }.bind(this)

  self.editing = false

  this.grabEdit = function(e) {
    self.editing = self.editing!=e.item._id && e.item._id || false
  }.bind(this)
  this.saveItem = function(fld) {
    return function(e) {
      var val = self.refs['item_'+fld].value,
          item = e.item,
          old = e.item[fld];
      e.item[fld] = val;
      var data = {
			      event: 'route_tag',
			      tag: item.name,
			      tag_id: item._id,
			      pv: 'campaign-tag',
			      customer: item.customer_id,
			      market: item.customer.market
			    },
			    crypto_pixel = encrypt( JSON.stringify(data) ),
			    update = {
			      [fld]:val,
			      crypto_pixel
			    }
	    if (item.link) {
	      data._redirect = item.link
		    update.crypto_link = encrypt( JSON.stringify(data) );
		  }
console.log('data',data,update)

      var lookups = []
      lookups.push(tinyURL(item.tag_base+crypto_pixel))
      if (item.link) lookups.push(tinyURL(item.tag_base+update.crypto_link))
      Promise.all(lookups)
      .then( tiny => {
        if (tiny[0]=='Error') return console.log('error getting tiny pixel')
        update.tiny_pixel = tiny[0]
        if (tiny[1]) {
           if(tiny[1]=='Error') return console.log('error getting tiny link')
           update.tiny_link = tiny[1]
        }
        return api.service('route_tags').patch(item._id,update)
      })
      .then(r => {
         Object.assign(e.item,update)
         self.update()
         api.emit('toast',{type:'info',title:'Tag saved'})
      })
      .catch(e => {
         console.log('ERROR tag',e)
         api.emit('toast', { type:'danger', title:'Error updating tag', content:e.message })
         self.refs['item_'+fld].value = old
         e.item[fld] = old
      })
      e.preventUpdate = true
    }
  }.bind(this)
  this.deleteItem = function(e) {
    e.preventDefault()
    api.service('route_tags')
       .remove(e.item._id)
       .then(r => {
         api.emit('toast',{type:'info',title:'Tag '+e.item.name+' removed'})
         loadTags()
       })
       .catch(e => {
         console.log('ERROR tag',e)
         api.emit('toast', { type:'danger', title:'Error removing tag', content:e.message })
       })
    e.preventUpdate = true
  }.bind(this)

  const copyToClipboard = (str,cb) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    const selected =
      document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
    cb && cb()
  };
  this.copyAttribute = function(fld,label) {
    return function(e) {
      e.preventDefault()
      var el = e.target,
          val = el.getAttribute(fld);
      copyToClipboard(val,function() {
        api.emit('toast',{type:'info',title:label + ' copied to clipboard'})
      })
    }
  }.bind(this)

  self.route_tags = [];

  self.on('mount',() => {
    loadTags()
  })

  let last_id = false, last_name = false

  function loadTags(append=false) {
    self.search_active = true;
	  self.update()

	  var filter = Object.assign({},self.filter)
	  if (append && last_id) {

	    filter.$or = [
	      {name:{$gt: last_name}},
	      {name:last_name,_id:{$gt: {_oid:last_id}}}
	    ]
	  }

    api.on('update-customer',function(e) {
      var customers = api.get('customers'),
          market = self.filter.market;
		  self.customers = market ? customers.filter(c => c.market==market) : customers;
    })

	  core.customerAPI.GetOrSet()
	  .then(customers => {

	    var market = self.filter.market;
		  self.customers = market ? customers.filter(c => c.market==market) : customers;
console.log('have customers',self.customers)
		  var lfilter = Object.assign({},filter)
  	  if (market && !lfilter.customer_id) lfilter.customer_id = {$in: self.customers.map( c => ({_oid:c._id}) )}
  	  delete lfilter.market
console.log('query',append,lfilter)
      return api.service('route_tags').find({query:lfilter})
    })
	  .then(tags => {
		  const ctags = tags.data.map(t => {
		    t.customer = self.customers.find(c => c._id==t.customer_id);
		    return t
		  });
console.log('catgs',ctags)
      if (append) {
        self.route_tags = self.route_tags.concat(ctags)
      } else {
        self.route_tags = ctags
      }
      last_id = tags.data.length && tags.data[tags.data.length-1]._id || false
      last_name = tags.data.length && tags.data[tags.data.length-1].name || false
      self.end_of_line = tags.data.length < filter.$limit
		  var tag_ids = tags.data.map(t => t._id)
		  return Promise.all([

		  ])
		})
		.then(tag_data => {
		  var all_users = new Set()
      self.tag_data = self.tag_data || {}

	  })
	  .then(cookie_ids => {

      self.cookie_ids = {}
		  self.search_active = false;
		  self.update();
	  })
	  .catch(err => api.emit('toast', { type:'danger', title:'Error fetching tags', content:err.message }));
  }

  this.loadMore = function(e) {
    e.preventDefault()
    e.preventUpdate = true
    loadTags(true)
  }.bind(this)

  this.createTag = function(e) {
    e.preventDefault()
    let name = self.refs.new_name.value,
        customer_id = self.refs.customer.value

    if (!name) return api.emit('toast',{type:'danger',title:'Name cannot be emtpy'})
    if (!customer_id) return api.emit('toast',{type:'danger',title:'Select customer first'})

    let customer = self.customers.find(c => c._id==customer_id),
        owner = customer.owner_id

console.log('owner',typeof owner,owner)

    let tag_id = ObjectId(),
        data = {
		      event: 'route_tag',
		      tag: name,
		      tag_id: tag_id,
		      pv: 'campaign-tag',
		      customer: customer_id,
		      market: customer.market
		    },
        market = customer.market || 'sl',
        collector = conf.collector_sr,
		    tag_base = collector + customer.market + '/collect?_cdata=',
		    crypto_pixel = encrypt( JSON.stringify(data) )

console.log('getting pixel',crypto_pixel)
		tinyURL(tag_base+crypto_pixel)
		.then(tiny_pixel => {
console.log('have pixel',tiny_pixel)

      return api.service('route_tags')
      .create({
        _id: {_oid:tag_id},
        tag_id: tag_id,
        name: name,
        owner_id: {_oid:owner},
        customer_id: {_oid:customer_id},
        market,
        tag_base,
        crypto_pixel,
        tiny_pixel
      })
    })
    .then(tag => {
      console.log('created tag',tag,self.route_tags)
      api.emit('toast',{type:'info',title:'Tag created'})
      self.editing = tag._id
      loadTags()
    })
    .catch(e => {
      api.emit('toast',{type:'danger',title:'Error creating tag',content:e.message})
      console.log('error creating tag',e)
    })
    e.preventUpdate = true
  }.bind(this)

});
